import { EChartsType } from 'echarts/core';
import * as echarts from 'echarts/core';

export abstract class BaseChartComponent {
    static $inject = ['$element'];

    protected chart?: EChartsType;
    private resizeListener = () => this.chart?.resize();

    constructor(private $element: ng.IRootElementService) {}

    $onDestroy() {
        window.removeEventListener('resize', this.resizeListener);
    }

    $onInit() {
        window.addEventListener('resize', this.resizeListener);

        setTimeout(() => this.createChart(), 10);
    }

    protected async createChart() {
        await this.whenDataReady();

        const element = this.$element.find('.target_chart_element')[0] as HTMLDivElement;
        this.chart = echarts.init(element);

        this.initializeChart(this.chart);
    }

    abstract whenDataReady(): Promise<boolean>;
    abstract initializeChart(chart: EChartsType): void;
}
